export const RESET_QUEST = "RESET_QUEST";
export const UPDATE_QUEST = "UPDATE_QUEST";
export const UPDATE_QUEST_GROUP = "UPDATE_QUEST_GROUP";
export const UNLOCK_QUEST = "UNLOCK_QUEST";
export const HIDE_QUEST = "HIDE_QUEST";
